import { render } from "./MultiSelect.vue?vue&type=template&id=233210a6&scoped=true"
import script from "./MultiSelect.vue?vue&type=script&lang=js"
export * from "./MultiSelect.vue?vue&type=script&lang=js"

import "./MultiSelect.vue?vue&type=style&index=0&id=233210a6&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-233210a6"]])

export default __exports__